import {
  Component,
  ElementRef,
  HostListener,
  Inject,
  Input,
  OnInit,
  Renderer2,
  forwardRef
} from "@angular/core";

import { BaseOptionComponent, BaseSelectComponent } from "../base";
import { TransferOptionsListComponent } from "./transfer-options-list.component";

@Component({
  selector: "ta-transfer-option",
  template: `
    <div
      [ngClass]="{
        'transfer-list__option--disabled': disabled,
        'transfer-list__option--disallowed': disallowed
      }"
    >
      <ng-template
        [ngTemplateOutlet]="optionLayoutTemplate"
        [ngTemplateOutletContext]="{ $implicit: option, model: option }"
      ></ng-template>
    </div>
  `
})
export class TransferListOptionComponent<Model>
  extends BaseOptionComponent<Model>
  implements OnInit {
  @Input()
  option: Model;

  @Input()
  disabled = false;

  @Input()
  disallowed = false;

  @HostListener("click", ["$event"])
  onClick(event: Event): void {
    if (this.disabled) {
      return;
    }
    if (this.isDoubleClick()) {
      this.optionsList.toggleSelectedOptions();
      return;
    }

    this.optionsList.setSelected(this.option);
    this.optionsList.lastSelected = this.option;
  }

  constructor(
    @Inject(BaseSelectComponent) selectElem: any,
    @Inject(forwardRef(() => TransferOptionsListComponent))
    public optionsList: any,
    elemRef: ElementRef,
    renderer: Renderer2
  ) {
    super(selectElem, optionsList, elemRef, renderer);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.initSelectedOptionsSubscription();
  }

  private initSelectedOptionsSubscription(): void {
    let wasSelected = false;

    this.optionsList.selected.subscribe(() => {
      const selected = this.optionsList.selected.value.includes(this.option);
      if (selected && !wasSelected) {
        this.renderer.addClass(
          this.elemRef.nativeElement,
          this.selectClasses.optionSelected
        );
        wasSelected = true;
      } else if (!selected && wasSelected) {
        this.renderer.removeClass(
          this.elemRef.nativeElement,
          this.selectClasses.optionSelected
        );
        wasSelected = false;
      }
    });
  }

  private isDoubleClick(): boolean {
    return (
      this.optionsList.lastSelected === this.option &&
      this.optionsList.selected.value.length === 1 &&
      this.optionsList.selected.value[0] === this.option
    );
  }
}
